(() => {
  'use strict';

  /**
   * Pumper uses offer indexes rather than actual quantities:
   * cb1/value 1 = 1 pair
   * cb2/value 2 = 3 pairs
   * cb3/value 3 = 5 pairs
   */
  const PUMPER_BUNDLE_MAP = Object.freeze({
    '1': 1,
    '2': 3,
    '3': 5,
  });

  const SELECTOR_INPUT =
    '.block__cbwrapper input.prvw_pair[name="cb"]';

  const ADD_TO_CART_BUTTON =
    'button[type="submit"][name="add"][data-add-to-cart]';

  function getBundleSize(input) {
    if (!(input instanceof HTMLInputElement)) return null;

    return PUMPER_BUNDLE_MAP[input.value] ?? null;
  }

  function parseMoney(value) {
    if (typeof value !== 'string') return null;

    const amount = Number.parseFloat(
      value.replace(/[^0-9.-]+/g, '')
    );

    return Number.isFinite(amount) ? amount : null;
  }

  function getOfferDetails(input) {
    const bundleSize = getBundleSize(input);

    if (!bundleSize) return null;

    const wrapper = input.closest('.template_4_block_wrapper');
    const label = wrapper?.querySelector(`label[for="${input.id}"]`);

    const offerName =
      label?.querySelector(
        '.template_4_block__cbmain--content--left__top h5'
      )?.textContent?.trim() || `${bundleSize} Pair`;

    const displayedPrice = parseMoney(
      label?.querySelector('.prvw_totalAmount_wrapper h4')
        ?.textContent
    );

    const originalPrice = parseMoney(
      label?.querySelector('.template_4_prevprice')
        ?.textContent
    );

    const discountLabel =
      label
        ?.querySelector(
          '.template_4_block__cbmain--content--left__top h4'
        )
        ?.textContent?.trim() || null;

    const merchandisingBadge =
      label
        ?.querySelector('.template_4_most_popular_wrapper h6')
        ?.textContent?.trim() || null;

    return {
      bundle_size: bundleSize,
      offer_index: input.value,
      offer_name: offerName,
      bundle_price: displayedPrice,
      original_price: originalPrice,
      discount_label: discountLabel,
      merchandising_badge: merchandisingBadge,
      free_shipping:
        label?.textContent?.includes('Free Shipping') || false,
      product_handle: getProductHandle(),
      product_path: window.location.pathname,
      page_title: document.title,
      selection_location: 'pdp',
      currency: 'USD',
    };
  }

  function getProductHandle() {
    const match = window.location.pathname.match(
      /^\/products\/([^/?#]+)/
    );

    return match?.[1] || null;
  }

  function getSelectedPumperInput() {
    return document.querySelector(
      `${SELECTOR_INPUT}:checked`
    );
  }

function publishShopifyEvent(eventName, data) {
  if (
    !window.Shopify?.analytics ||
    typeof window.Shopify.analytics.publish !== 'function'
  ) {
    console.warn(
      `[Michael Antione Analytics] Shopify analytics unavailable for ${eventName}.`,
      data
    );
    return false;
  }

  try {
    window.Shopify.analytics.publish(eventName, data);

    console.info(
      `[Michael Antione Analytics] Published ${eventName}:`,
      data
    );

    return true;
  } catch (error) {
    console.error(
      `[Michael Antione Analytics] Failed to publish ${eventName}:`,
      error
    );

    return false;
  }
}
  /**
   * Track an actual customer selection.
   * This does not fire merely because Pumper preselects the 3-pack.
   */
  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(SELECTOR_INPUT);

    if (!input || !input.checked) return;

    const offer = getOfferDetails(input);

    if (!offer) return;

    publishShopifyEvent('ma:bundle_selected', offer);

    console.info(
      '[Michael Antione Analytics] Bundle selected:',
      offer
    );
  });

  /**
   * Track the selected bundle when Add to Cart is pressed.
   * Capture phase helps us record the selection before the app/theme
   * changes the page or opens the cart drawer.
   */
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.(
        ADD_TO_CART_BUTTON
      );

      if (!button) return;

      const selectedInput = getSelectedPumperInput();

      if (!selectedInput) {
        console.warn(
          '[Michael Antione Analytics] Add to Cart clicked without a selected Pumper offer.'
        );
        return;
      }

      const offer = getOfferDetails(selectedInput);

      if (!offer) return;

      publishShopifyEvent('ma:bundle_add_to_cart', offer);

      console.info(
        '[Michael Antione Analytics] Bundle Add to Cart:',
        offer
      );
    },
    true
  );
})();